// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import axios from 'axios'
import swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import App from './App'
import router from './router'
import {
  sync
} from 'vuex-router-sync'
import './permission'
sync(store, router)
window.$ = window.jQuery = require('jquery')
const url = window.location.hostname === 'localhost' ? 'http://localhost:2400' : 'https://api.brfin.sistemaweb.com.br'

Vue.prototype.$url = url

Vue.config.productionTip = false

axios.defaults.baseURL = url

// Se o backend retornar 401 ou erro de rede (ex: CORS bloqueia resposta 401), limpar token e mandar para login.
axios.interceptors.response.use(
  response => response,
  error => {
    const status = error && error.response ? error.response.status : null
    const isNetworkError = !error.response && (error.message === 'Network Error' || error.code === 'ERR_NETWORK')
    const hasToken = !!localStorage.getItem('token')

    // 401 ou erro de rede com token (CORS costuma esconder o 401 como Network Error)
    if (status === 401 || (isNetworkError && hasToken)) {
      localStorage.clear()
      if (router && router.currentRoute && router.currentRoute.path !== '/acessar') {
        router.push('/acessar').catch(() => {})
      } else {
        window.location = '/acessar'
      }
    }
    return Promise.reject(error)
  }
)

if (localStorage.getItem('token')) {
  new Promise((resolve) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`
    resolve()
  }).catch(() => {
    localStorage.clear()
    window.location = '/acessar'
  })
}
Vue.prototype.$axios = axios
Vue.prototype.$swal = swal

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
